import { createFileRoute } from '@tanstack/react-router';

import { AdminWbrPage } from '@apps/web/features/admin_wbr';

export const Route = createFileRoute('/_app/admin/wbr')({
    head: () => ({ meta: [{ title: 'WBR | Phoebe Admin' }] }),
    component: AdminWbrPage,
});
